/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_BuscadorPersona as BuscadorPersona,
  rec_Er as Er,
  rec_Ix as Ix,
  rec_JD as JD,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_SelectorFecha as SelectorFecha,
  rec_SelectorFechaHora as SelectorFechaHora,
  rec_SelectorMultiple as SelectorMultiple,
  rec_XC as XC,
  rec_ZC as ZC,
  rec_aS as aS,
  rec_api as api,
  rec_obtenerUsuario as obtenerUsuario,
  rec_ra as ra,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function NuevaReunion({
  proyectoId: e = null,
  unidadId: t = null,
  proyectosPosibles: n = [],
  areasPosibles: r = [],
  fechaInicial: i = ``,
  onClose: a,
  onGuardado: o,
}) {
  let [s, c] = (0, React.useState)({
      titulo: ``,
      agenda: ``,
      fechaHora: i,
      duracionMin: 60,
      modalidad: `PRESENCIAL`,
      lugarOEnlace: ``,
      recurrencia: `NINGUNA`,
      repetirHasta: ``,
    }),
    [l, u] = (0, React.useState)(() => (r.length === 1 ? String(r[0].id) : ``)),
    [f, p] = (0, React.useState)([]),
    [m, h] = (0, React.useState)(``),
    [g, _] = (0, React.useState)([]),
    [v, y] = (0, React.useState)([]),
    [b, x] = (0, React.useState)([]),
    [S, C] = (0, React.useState)(``),
    [w, T] = (0, React.useState)(!1),
    [E, D] = (0, React.useState)(null),
    O = (e, t) =>
      c((n) => ({
        ...n,
        [e]: t,
      })),
    k = t ?? (l ? Number(l) : null),
    A = (0, React.useMemo)(() => {
      let e = m.trim().toLowerCase(),
        t = n.filter((e) => f.includes(e.id)),
        r = n.filter(
          (t) =>
            !f.includes(t.id) && (!e || t.nombre.toLowerCase().includes(e)),
        );
      return [...t, ...r.slice(0, JD)];
    }, [n, f, m]),
    j = n.length - A.length;
  (0, React.useEffect)(() => {
    if (!k) {
      (_([]), y([]));
      return;
    }
    let e = !0;
    return (
      api(`/unidades/${k}/sedes`)
        .then((t) => {
          if (!e) return;
          let n = t ?? [];
          (_(n), y(n.length > 0 ? [n[0].sedeId] : []));
        })
        .catch(() => {
          e && (_([]), y([]));
        }),
      () => {
        e = !1;
      }
    );
  }, [k]);
  async function M(t) {
    if ((t.preventDefault(), !w)) {
      T(!0);
      try {
        let t = await api(`/reuniones`, {
          method: `POST`,
          body: JSON.stringify({
            proyectoId: e,
            unidadId: k,
            proyectosTratadosIds: f,
            sedes: v.map((e) => ({
              sedeId: e,
            })),
            ...s,
            duracionMin: Number(s.duracionMin) || null,
            repetirHasta:
              s.recurrencia === `NINGUNA` ? null : s.repetirHasta || null,
            actorNombre: obtenerUsuario()?.nombre,
            participantes: b.map((e) => ({
              usuarioId: e.id,
              usuarioNombre: e.nombre,
              usuarioCorreo: e.correo,
            })),
          }),
        });
        (o(),
          D({
            ...t,
            titulo: s.titulo,
            agenda: s.agenda,
            fechaHora: s.fechaHora,
            duracionMin: Number(s.duracionMin) || 60,
            lugarOEnlace: s.lugarOEnlace,
            participantes: b.map((e) => ({
              usuarioCorreo: e.correo,
            })),
          }));
      } catch (e) {
        (C(e.message), T(!1));
      }
    }
  }
  return E ? (
    <Modal
      titulo={`Reunión creada`}
      onClose={a}
      ancho={`max-w-lg`}
      children={
        <div
          className={`flex flex-col gap-3 text-sm text-(--text)`}
          children={[
            E.ocurrenciasCreadas > 1 && (
              <p
                children={[
                  `Se crearon `,
                  E.ocurrenciasCreadas,
                  ` reuniones de la serie.`,
                ]}
              />
            ),
            <p
              children={`Podés registrarla también en Teams (abre el formulario de nueva reunión con los datos cargados; no se sincroniza después).`}
            />,
            <div
              className={`flex flex-wrap justify-end gap-2`}
              children={[
                <button
                  type={`button`}
                  onClick={a}
                  className={zo}
                  children={`Listo`}
                />,
                aS(E) && (
                  <a
                    href={aS(E)}
                    target={`_blank`}
                    rel={`noreferrer`}
                    className={`${Ro} inline-flex items-center gap-1.5`}
                    children={[
                      <Er className={`h-4 w-4`} />,
                      ` Registrar en Teams`,
                    ]}
                  />
                ),
              ]}
            />,
          ]}
        />
      }
    />
  ) : (
    <Modal
      titulo={`Nueva reunión`}
      onClose={a}
      ancho={`max-w-lg`}
      children={
        <form
          onSubmit={M}
          className={`flex flex-col gap-3`}
          children={[
            r.length > 0 && (
              <label
                className={`text-xs text-(--text)`}
                children={[
                  `Área`,
                  <SelectorMultiple
                    value={l}
                    onChange={(e) => u(e || ``)}
                    placeholder={`Elegí el área`}
                    opciones={r.map((e) => ({
                      value: String(e.id),
                      label: ZC(e.nombre, e),
                    }))}
                  />,
                ]}
              />
            ),
            <input
              className={Lo}
              placeholder={`Título`}
              value={s.titulo}
              onChange={(e) => O(`titulo`, e.target.value)}
              required={!0}
              autoFocus={!0}
            />,
            <textarea
              className={`${Lo} min-h-16`}
              placeholder={`Agenda / puntos a tratar`}
              value={s.agenda}
              onChange={(e) => O(`agenda`, e.target.value)}
            />,
            <div
              className={`grid grid-cols-2 gap-3`}
              children={[
                <label
                  className={`text-xs text-(--text)`}
                  children={[
                    `Fecha y hora`,
                    <SelectorFechaHora
                      value={s.fechaHora}
                      onChange={(e) => O(`fechaHora`, e)}
                    />,
                  ]}
                />,
                <label
                  className={`text-xs text-(--text)`}
                  children={[
                    `Duración (min)`,
                    <input
                      type={`number`}
                      className={Lo}
                      value={s.duracionMin}
                      onChange={(e) => O(`duracionMin`, e.target.value)}
                    />,
                  ]}
                />,
                <label
                  className={`text-xs text-(--text)`}
                  children={[
                    `Modalidad`,
                    <SelectorMultiple
                      value={s.modalidad}
                      onChange={(e) => O(`modalidad`, e || `PRESENCIAL`)}
                      placeholder={`Presencial`}
                      opciones={[
                        {
                          value: `PRESENCIAL`,
                          label: `Presencial`,
                        },
                        {
                          value: `VIRTUAL`,
                          label: `Virtual`,
                        },
                        {
                          value: `HIBRIDA`,
                          label: `Híbrida`,
                        },
                      ]}
                    />,
                  ]}
                />,
                <label
                  className={`text-xs text-(--text)`}
                  children={[
                    `Lugar / enlace`,
                    <input
                      className={Lo}
                      value={s.lugarOEnlace}
                      onChange={(e) => O(`lugarOEnlace`, e.target.value)}
                    />,
                  ]}
                />,
                <label
                  className={`text-xs text-(--text)`}
                  children={[
                    `Repetir`,
                    <SelectorMultiple
                      value={s.recurrencia}
                      onChange={(e) => O(`recurrencia`, e || `NINGUNA`)}
                      placeholder={`No se repite`}
                      opciones={Ix.filter((e) => e.codigo !== `NINGUNA`).map(
                        (e) => ({
                          value: e.codigo,
                          label: e.label,
                        }),
                      )}
                    />,
                  ]}
                />,
                s.recurrencia !== `NINGUNA` && (
                  <label
                    className={`text-xs text-(--text)`}
                    children={[
                      `Repetir hasta`,
                      <SelectorFecha
                        value={s.repetirHasta}
                        onChange={(e) => O(`repetirHasta`, e)}
                      />,
                    ]}
                  />
                ),
              ]}
            />,
            g.length > 1 && (
              <div
                children={[
                  <p
                    className={`text-xs text-(--text)`}
                    children={`¿Qué sedes participan?`}
                  />,
                  <div
                    className={`mt-1 flex flex-wrap gap-1`}
                    children={g.map((e, t) => {
                      let n = t === 0,
                        r = v.includes(e.sedeId);
                      return (
                        <button
                          key={e.sedeId}
                          type={`button`}
                          disabled={n}
                          onClick={() =>
                            y((t) =>
                              r
                                ? t.filter((t) => t !== e.sedeId)
                                : [...t, e.sedeId],
                            )
                          }
                          className={`flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs transition ${r ? `border-(--accent) bg-(--accent-bg) text-(--text-h)` : `border-(--border) text-(--text) hover:bg-(--accent-bg)`} ${n ? `cursor-default` : ``}`}
                          children={[
                            <span
                              className={`h-1.5 w-1.5 shrink-0 rounded-full`}
                              style={{
                                background: XC(e.sedeId),
                              }}
                            />,
                            e.nombre,
                          ]}
                        />
                      );
                    })}
                  />,
                ]}
              />
            ),
            n.length > 0 && (
              <div
                children={[
                  <p
                    className={`text-xs text-(--text)`}
                    children={`¿Sobre qué proyectos?`}
                  />,
                  n.length > JD && (
                    <input
                      className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg) mt-1`}
                      placeholder={`Buscar un proyecto…`}
                      value={m}
                      onChange={(e) => h(e.target.value)}
                    />
                  ),
                  <div
                    className={`mt-1 flex flex-wrap gap-1`}
                    children={A.map((e) => {
                      let t = f.includes(e.id);
                      return (
                        <button
                          key={e.id}
                          type={`button`}
                          onClick={() =>
                            p((n) =>
                              t ? n.filter((t) => t !== e.id) : [...n, e.id],
                            )
                          }
                          className={`rounded-full border px-2.5 py-1 text-xs transition ${t ? `border-(--accent) bg-(--accent-bg) text-(--text-h)` : `border-(--border) text-(--text) hover:bg-(--accent-bg)`}`}
                          children={e.nombre}
                        />
                      );
                    })}
                  />,
                  j > 0 && (
                    <p
                      className={`mt-1 text-xs text-(--text)`}
                      children={[
                        j === 1
                          ? `Hay 1 proyecto más`
                          : `Hay ${j} proyectos más`,
                        ` — buscalo por nombre.`,
                      ]}
                    />
                  ),
                  A.length === 0 && (
                    <p
                      className={`mt-1 text-xs text-(--text)`}
                      children={`Ningún proyecto se llama así.`}
                    />
                  ),
                  <p
                    className={`mt-1 text-xs text-(--text)`}
                    children={`Si no es de ninguno en particular, dejalo sin marcar.`}
                  />,
                ]}
              />
            ),
            <div
              children={[
                <p
                  className={`text-xs text-(--text)`}
                  children={`Participantes`}
                />,
                <div
                  className={`mb-1 flex flex-wrap gap-1`}
                  children={b.map((e) => (
                    <span
                      key={e.id}
                      className={`flex items-center gap-1 rounded-full bg-(--accent-bg) px-2 py-0.5 text-xs text-(--text-h)`}
                      children={[
                        e.nombre,
                        <button
                          type={`button`}
                          onClick={() =>
                            x((t) => t.filter((t) => t.id !== e.id))
                          }
                          children={(0, JSXRuntime.jsx)(ra, {
                            className: `h-3 w-3`,
                          })}
                        />,
                      ]}
                    />
                  ))}
                />,
                <BuscadorPersona
                  placeholder={`Agregar participante…`}
                  excluirIds={b.map((e) => e.id)}
                  onSelect={(e) => x((t) => [...t, e])}
                />,
              ]}
            />,
            S && <p className={`text-sm text-(--error)`} children={S} />,
            <div
              className={`flex justify-end gap-2`}
              children={[
                <button
                  type={`button`}
                  onClick={a}
                  className={zo}
                  children={`Cancelar`}
                />,
                <button
                  type={`submit`}
                  disabled={w || !s.fechaHora || (r.length > 0 && !l)}
                  className={Ro}
                  children={`Crear`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
